import React, { useEffect, useState } from "react";
import { UrlApi } from "../../../services/apirest";
import { Container, DialogTitle, IconButton, Typography, SnackbarContent, TextField, Select, Grid, InputLabel, MenuItem, FormControl, Button, Box, InputAdornment } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AccessibilityNewIcon from "@mui/icons-material/AccessibilityNew";
import CallIcon from "@mui/icons-material/Call";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import { grey } from "@mui/material/colors";
import Notify from "../../Notify";
import Alerta from "../../Alerta";

function Addsupervisores(props) {
    const [datosformulario, setDatosformulario] = useState(props.datos);
    const [sucursales, setSucursales] = useState();
    const [openSnack, setOpenSnack] = React.useState(false);
    const [colormensaje, setColorMensaje] = useState("");
    const [mensaje, setMensaje] = useState("");
    const [notificacion, setNotificacion] = useState(false); //define si se muestra o no una notificación (snackbar)
    const [error, setError] = useState(null); //guardará el error que lance la api (si existe)
    const [mensajeAlerta, setMensajeAlerta] = useState(""); //mensaje que contendrá el componente "alerta"
    const [finalizar, setFinalizar] = useState(); //finalizar === 1 lo manda como prop el componente "notify" e indica que la transaccion ha finalizado y debe ejecutarse la funcion para cerrar
    const [severityAlerta, setSeverityAlerta] = useState(""); //define severidad de la alerta (success error o warning)
    const [severitySnack, setSeveritySnack] = useState(""); //define severidad del snackbar (notificación)

    //Funcion para almacenar los datos (se ejecuta en el onchange de los textfield/select)
    const almacenar = (e) => {
        setDatosformulario({
            ...datosformulario,
            [e.target.name]: e.target.value,
        }); // almacena datos del formulario y lo q se guarda en las constantees usuario y activo
    };

    const obtenerSucursales = () => {
        fetch(UrlApi + "/sucursales")
            .then((data) => data.json())
            .then((data) => setSucursales(data));
    };

    useEffect(() => {
        obtenerSucursales();
    }, []);

    const handleClose = () => {
        props.editar(false);
        props.tabla(true);
    };

    // funcion para guardar el supervisor
    const guardarSupervisor = async () => {
        let response = await fetch(UrlApi + "/supervisores", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                nombre_apellido:datosformulario.nombre_apellido,
                telefono:datosformulario.telefono,
                mail:datosformulario.mail,
                id_sucursal:datosformulario.id_sucursal,
                usuario:localStorage.getItem('user'),
              }
        ),
        })
        if (response.ok === false) {
            console.log("ERROR EN API");
            const error = response && response.json();
            setError(error);
            setSeverityAlerta("error")
            setMensajeAlerta("Inconvenientes con la API. No se pudo guardar. ");
        } else {
            console.log("Conexión con api OK");
            try {
                //Parseo respuesta de la api a json()
                const json = await response.json();
                //si api me devuelve lo q le puse en message
                if (json.message) {
                    //Si ese mensaje es "OK"
                    if (json.message === "OK") {
                        console.log("Guardado Satisfactoriamente");
                        setNotificacion(true);
                        setOpenSnack(true);
                        setColorMensaje("#D4EFDF");
                        setMensaje("Guardado");
                        setSeveritySnack("success");
                    } else {
                        console.log("res en api incorrecto. Revisar que sea 'OK'")
                        setNotificacion(true);
                        setOpenSnack(true);
                        setColorMensaje("#D4EFDF");
                        setSeveritySnack("error");
                        setMensaje("Registro Guardado. REVISAR RESPUESTA DE API (E_S)");
                    }
                } else if (json.sqlMessage) {
                    json && setError(json);
                    console.log(json);
                    setMensajeAlerta("SQL erróneo (" + json.code + " Errno: " + json.errno + " )");
                } else {
                    setMensajeAlerta("ERROR DESCONOCIDO.");
                }
            } catch (error) {
                if (error.toString().includes("is not valid JSON")) {
                    console.log("Guardado. Advertencia: Actualizar respuesta de api. JSON invalido.");
                    setNotificacion(true);
                    setOpenSnack(true);
                    setColorMensaje("#D4EFDF");
                    setMensaje("Guardado");
                    setSeveritySnack("success");
                } else {
                    setMensajeAlerta("ERROR DESCONOCIDO.");
                }
            }
        }
        handleClose()
    };

    const style = {
        backgroundColor: "#ffffff",
        width: "100%"
    };

    return (
        <div>
            <Container>
                <Box sx={{ flexGrow: 1 }} mt={2}>
                    <Grid container backgroundColor="#1F618D" p={1.5}>
                        <Grid item xs={2}>
                            <IconButton onClick={handleClose}>
                                <ArrowBackIcon sx={{ color: grey[50] }} />
                            </IconButton>
                        </Grid>

                        <Grid
                            item
                            xs={8}
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                        >
                            <Typography variant="h5" color="#ffffff">
                                Editar supervisor
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
                <form onSubmit={guardarSupervisor}>
                    <Box
                        backgroundColor="#F4F6F6"
                        mt={2}
                        p={3}
                        border={0.5}
                        borderColor={"#ABB2B9"}
                        borderRadius={4}
                    >
                        <Grid container spacing={1} direction={{ xs: 'column', sm: 'row' }}>
                            <Grid item xs={6}>
                                <TextField
                                    placeholder="Nombre Completo"
                                    required
                                    focused
                                    name="nombre_apellido"
                                    style={style}
                                    id="nombre_completo"
                                    label="Nombre Completo"
                                    color="primary"
                                    onChange={almacenar}
                                    value={datosformulario.nombre_apellido && datosformulario.nombre_apellido.replace(/\b\w/g, (l) =>
                                        l.toUpperCase()
                                    )}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <AccessibilityNewIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    placeholder="Teléfono"
                                    //required
                                    focused
                                    type="number"
                                    style={style}
                                    name="telefono"
                                    id="telefono"
                                    label="Teléfono"
                                    color="primary"
                                    onChange={almacenar}
                                    value={datosformulario.telefono}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <CallIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    placeholder="Mail"
                                    //required
                                    focused
                                    name="mail"
                                    type="mail"
                                    style={style}
                                    id="mail"
                                    label="Mail"
                                    color="primary"
                                    onChange={almacenar}
                                    value={datosformulario.mail}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <ContactMailIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl style={style} focused>
                                    <InputLabel>Sucursal</InputLabel>
                                    <Select
                                        name="id_sucursal"
                                        required
                                        InputLabelProps={{ shrink: true, required: true }}
                                        labelId="demo-simple-select-label"
                                        value={datosformulario.id_sucursal}
                                        label="Sucursal"
                                        onChange={almacenar}
                                    >
                                        {sucursales
                                            ? sucursales.map((elemento) => (
                                                <MenuItem key={elemento.id} value={elemento.id}>
                                                    {elemento.nombre}
                                                </MenuItem>
                                            ))
                                            : null}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container
                            justifyContent="space-between"
                            alignItems="flex-end"
                            mt={2}>
                            <Button variant="contained" color="error" onClick={handleClose}>
                                Cancelar
                            </Button>
                            <Button variant="contained" type="submit" color="success">
                                Guardar Supervisor
                            </Button>

                        </Grid>
                    </Box>
                    {notificacion ? (
                        <Notify
                            mensaje={mensaje}
                            open={openSnack}
                            color={colormensaje}
                            finalizar={setFinalizar}
                            severity={severitySnack}
                        />
                    ) : null}
                    {/* ALERT --> SE MUESTRA SI HAY UN ERROR EN LA API (NO SE CONECTA O ESTÁ MAL LA RUTA, ETC.) */}
                    {error && mensajeAlerta ? (
                        <Alerta mensaje={mensajeAlerta} severity={severityAlerta} />
                    ) : null}
                </form>
            </Container>
        </div>
    );
}

export default Addsupervisores;
